import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

// Configure the persister with compression and error handling
export const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'PICKSCITY_QUERY_CACHE',
  serialize: (data) => {
    try {
      // Compress data to save space
      return JSON.stringify(data);
    } catch (error) {
      console.error('Failed to serialize cache:', error);
      return '';
    }
  },
  deserialize: (data) => {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error('Failed to deserialize cache:', error);
      return undefined;
    }
  },
});

// Get cache statistics
export const getCacheStats = () => {
  const cache = localStorage.getItem('PICKSCITY_QUERY_CACHE');
  if (!cache) return { size: 0, entries: 0 };

  try {
    const parsed = JSON.parse(cache);
    const size = new Blob([cache]).size;
    const entries = Object.keys(parsed.clientState.queries || {}).length;

    return {
      size,
      sizeInKB: Math.round(size / 1024 * 100) / 100,
      entries,
      lastUpdated: parsed.timestamp,
    };
  } catch {
    return { size: 0, entries: 0 };
  }
};